/* cc-pdp-sticky.js - 21 October 2026
 *
 * Two small things on the product page, both passive:
 *  1. A sticky "price + Add to cart" bar on phones, shown once the real Add to
 *     cart has scrolled out of view. It mirrors the chosen price and size and
 *     clicks the real button, so the existing add-to-cart code does the work.
 *  2. The delivery estimate line: today plus the worst-case days for the
 *     visitor's market (data-days, from the same figures as the Christmas
 *     order-by dates), formatted for the page language.
 * No scroll listener: an IntersectionObserver and a MutationObserver only.
 */
(function () {
  'use strict';
  var atc = document.querySelector('[data-cc-atc]');
  if (!atc) return;

  /* ---- delivery estimate ---- */
  var eta = document.querySelector('[data-cc-eta]');
  if (eta) {
    var days = parseInt(eta.getAttribute('data-days'), 10);
    var country = eta.getAttribute('data-country');
    if (days > 0) {
      var d = new Date();
      d.setDate(d.getDate() + days);
      var lang = document.documentElement.lang || 'en';
      if (lang === 'en') lang = 'en-AU';
      var txt;
      try { txt = d.toLocaleDateString(lang, { day: 'numeric', month: 'long' }); } catch (e) { txt = d.toDateString().slice(4, 10); }
      eta.textContent = 'Order today and it arrives' + (country ? ' in ' + country : '') + ' by ' + txt + ' at the latest.';
      eta.hidden = false;
    }
  }

  /* ---- sticky buy bar ---- */
  var bar = document.querySelector('[data-cc-sticky]');
  if (!bar) return;
  var priceEl = document.querySelector('[data-cc-price]');
  var noteEl = document.querySelector('[data-cc-price-note]');
  var outPrice = bar.querySelector('[data-cc-sticky-price]');
  var outNote = bar.querySelector('[data-cc-sticky-note]');
  var addBtn = bar.querySelector('[data-cc-sticky-add]');

  function sync() {
    if (priceEl && outPrice) outPrice.textContent = priceEl.textContent.trim();
    if (noteEl && outNote) outNote.textContent = noteEl.textContent.trim();
    addBtn.disabled = atc.disabled && !atc.classList.contains('cc-atc-confirming');
    addBtn.textContent = atc.classList.contains('cc-atc-confirming') ? atc.textContent : (atc.disabled ? atc.textContent : 'Add to cart');
    if (atcState === 'below') { addBtn.textContent = 'Choose size'; addBtn.disabled = false; }
  }
  sync();
  var mo = new MutationObserver(sync);
  [priceEl, noteEl].forEach(function (el) { if (el) mo.observe(el, { childList: true, characterData: true, subtree: true }); });
  mo.observe(atc, { attributes: true, childList: true, characterData: true, subtree: true });

  /* Where the real button is relative to the screen decides what the bar does:
       above the screen (already passed)  "Add to cart", clicks the real one
       below the screen, photograph gone  "Choose size", scrolls to the picker
       in view, or the photograph still on screen  no bar
     So a visitor is never more than a tap from the buy box, and a tap on a
     size-less bar can never add the default print by accident. */
  var stage = document.querySelector('[data-cc-stage]');
  var atcState = 'in';        /* in | above | below */
  var stageGone = false;
  var addLabel = addBtn.textContent;

  function render() {
    var show = atcState === 'above' || (atcState === 'below' && stageGone);
    bar.hidden = !show;
    document.documentElement.classList.toggle('cc-has-sticky-bar', show);
    if (!show) return;
    if (atcState === 'below') {
      addBtn.textContent = 'Choose size';
      addBtn.disabled = false;
    } else {
      sync();
    }
  }
  /* sync() writes the label for the "above" state; remember it for restore */
  addBtn.addEventListener('click', function () {
    if (atcState === 'below') {
      var target = document.querySelector('.cc-pdp2__price') || priceEl || atc;
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    } else {
      atc.click();
    }
  });

  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    var e = entries[0];
    atcState = e.isIntersecting ? 'in' : (e.boundingClientRect.bottom < 0 ? 'above' : 'below');
    render();
  }, { threshold: 0 }).observe(atc);
  if (stage) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      stageGone = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      render();
    }, { threshold: 0 }).observe(stage);
  }
})();
